import { InferType, object, string } from 'yup';

export const CareDocumentOutcomeSchema = object().shape({
  initial: string(),
  followUp: string(),
  change: string(),
});

export type CareDocumentOutcome = InferType<typeof CareDocumentOutcomeSchema>;
